import { render, staticRenderFns } from "./photo-material-loose.vue?vue&type=template&id=b5ed8288&scoped=true&"
import script from "./photo-material-loose.vue?vue&type=script&lang=js&"
export * from "./photo-material-loose.vue?vue&type=script&lang=js&"
import style0 from "./photo-material-loose.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./photo-material-loose.vue?vue&type=style&index=1&id=b5ed8288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ed8288",
  null
  
)

export default component.exports